import React, { Component } from 'react'
import classnames from 'classnames'
import autobind from 'autobind-decorator'
import { Link } from 'react-router-dom'

import FilterList from '../../constants/plugins/FilterList'
import WindowEventHelper from "../../lib/WindowEventHelper";

class PluginFilter extends Component {

	constructor() {
		super()
		this.state = {
			open: false
		}
	}

	componentDidMount() {
		WindowEventHelper.add("click", this.handleClose)
	}

	componentWillUnmount() {
		WindowEventHelper.remove("click", this.handleClose)
	}

	@autobind
	handleClose() {
		this.setState({
			open: false
		})
	}

	@autobind
	handleToggleOpen(e) {
		const { open } = this.state
		e.stopPropagation()
		this.setState({
			open: !open
		})
	}

	@autobind
	handleSelect(e, filter) {
		const { handleFilterPlugins } = this.props
		e.stopPropagation()
		handleFilterPlugins(filter)
	}

	render() {
		const { open } = this.state
		const { filter } = this.props
		return (
			<div className={classnames("opt_blog", { "opt_open": open })}>
				<button type="button" className="btn_opt" onClick={this.handleToggleOpen}>
					보기
					<span className="ico_blog ico_open" />
				</button>
				<div className="layer_opt">
					<ul className="list_opt">
						{ FilterList.map((item, index) =>
							<li key={index} className={classnames({ "on": item.category === filter })}>
								<Link className="lab_btn" to={`/plugins/${item.category}`}>
									{item.label}
									<input type="button" className="btn_g" onClick={e => this.handleSelect(e, item)} />
								</Link>
							</li>
						) }
					</ul>
				</div>
			</div>
		)
	}
}

export default PluginFilter
